export default __webpack_public_path__ + "static/love-disabl-6bad25051cc1a6308e19e52a141fcfd2.jpg";